import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError, of } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { AuthService } from './services/auth.service';
import { 
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { AlertModalService } from 'app/shared/alert-modal.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(
    public authService: AuthService,
    private alertService: AlertModalService,
    private router: Router) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

      let handled: boolean = false;
  
      if (this.authService.getJwtToken()) {
        request = this.addToken(request, this.authService.getJwtToken());
      }

      return next.handle(request)
      .pipe(
        retry(1),
        catchError((returnedError) => {
          
          let errorMessage = null;

          console.log('Handle: ', returnedError);
  
          if (returnedError.error instanceof ErrorEvent) {
            // errorMessage = `Error Event: ${returnedError.error.error.Erros[0].message}`;
            errorMessage = returnedError.error.error;
          } else if (returnedError instanceof HttpErrorResponse) {
            errorMessage = returnedError.error;
            handled = this.handleServerSideError(returnedError);
          } 
      
          if (!handled) {
            if (errorMessage) {
              return throwError(errorMessage);
            } else {
              return throwError("Ocorreu um problema inesperado!");
            }
          } else {
            return of(returnedError);
          }
        })
      )
  }

  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  private handleServerSideError(error: HttpErrorResponse): boolean {
    let handled: boolean = false;
    let mensagem: string | undefined; // Variável para armazenar a mensagem

    if (error.error) {
      console.log('Erro:', error);
      mensagem = error.error.Erros[0].Mensagem;
    }


    switch (error.status) {
      case 400:
        console.error("Requisição inválida!");
        // this.alertService.showAlertDanger('Ocorreu um erro na sua requisição. Verifique os dados e tente novamente.');
        handled = false;
        break;
      case 401:
        console.error("Acesso não autorizado! Necessário realizar o login.");
        // if(mensagem === 'Falha ao autenticar') {
        //   this.alertService.showAlertDanger(mensagem + '!');
        // }
        // this.authService.logout();
        handled = false;
        break;
      case 403:
        console.warn("Esse usuário não tem permissão para acessar esse recurso!");
        // this.router.navigate(['/page-error']);
        handled = false;
        break;
      case 404:
        console.warn("Essa página não existe!");
        if(mensagem === 'Usuário não encontrado!') {
          this.alertService.showAlertDanger(mensagem);
        }
        this.router.navigate(['/page-error']);
        handled = true;
        break;
      case 500:
        console.warn("O servidor encontrou uma situação com a qual não sabe lidar.");
        handled = false;
        break;
      case 503:
        console.warn("O servidor está indisponível.");
        handled = false;
        break;
      case 504:
        console.warn("O servidor está demorando para responder.");
        handled = false;
        break;
      case 0:
        console.error("Status 0. Ocorreu um erro desconhecido!");
        this.router.navigate(['/page-error']);
        handled = true;
        break;
    }
    return handled;
  }

}

